"use strict";

var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useShowSuccessToast = void 0;
var _slicedToArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _Toast = require("../../components/toast/Toast");
var _react = _interopRequireWildcard(require("react"));
var _useTranslation2 = require("../useTranslation/useTranslation");
var AUTO_DELETE_TIME = 5 * 1000;
var DISAPPEAR_ANIMATION_TIME = 500;
var useShowSuccessToast = function useShowSuccessToast() {
  var toastId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'success-toasts';
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    disappearTimeInMs: AUTO_DELETE_TIME
  };
  var _useTranslation = (0, _useTranslation2.useTranslation)(),
    t = _useTranslation.t;
  var _useState = (0, _react.useState)([]),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    toastList = _useState2[0],
    setToastList = _useState2[1];
  var showSuccess = function showSuccess(message) {
    setToastList([{
      id: 'error',
      description: message,
      title: t('common.success'),
      type: 'success'
    }]);
  };
  (0, _react.useEffect)(function () {
    var timeout = setTimeout(function () {
      if (toastList.length > 0) {
        setToastList([]);
      }
    }, options.disappearTimeInMs + DISAPPEAR_ANIMATION_TIME);
    return function () {
      return clearTimeout(timeout);
    };
  }, [toastList, options.disappearTimeInMs]);
  return [/*#__PURE__*/_react.default.createElement(_Toast.Toast, {
    autoDeleteTimeMs: options.disappearTimeInMs,
    toastList: toastList,
    key: toastId
  }), showSuccess];
};
exports.useShowSuccessToast = useShowSuccessToast;